"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _wx_work_config = require("@/api/cfg/wx_work_config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WxWorkConfigIndex',
  components: {},
  data: function data() {
    return {
      listQuery: {
        page: 1,
        limit: 20,
        keywords: null
      },
      comboboxList: [],
      records: [],
      total: 0,
      listLoading: false,
      dialogVisible: false,
      cfgForm: {
        originChannel: "wx_work",
        //来源渠道
        corpId: null,
        //企业ID
        corpName: null,
        //企业名称
        agentId: null,
        //应用ID
        agentName: null,
        //应用名称
        agentSecret: null,
        //应用密钥
        cropAddrBookSecret: null,
        //企业通讯录密钥
        cropAddrBookToken: null,
        //企业通讯录token
        cropAddrBookEncodingAesKey: null,
        //企业通讯录加密密钥
        customerRelationSecret: null,
        //客户关系密钥
        customerRelationToken: null,
        //客户关系token
        customerRelationEncodingAesKey: null //客户关系加密密钥
      },
      updateDialogVisible: false,
      updateField: {
        "agentSecret": "应用密钥",
        "cropAddrBookSecret": "企业通讯录密钥",
        "cropAddrBookToken": "企业通讯录token",
        "cropAddrBookEncodingAesKey": "企业通讯录加密密钥",
        "customerRelationSecret": "客户关系密钥",
        "customerRelationToken": "客户关系token",
        "customerRelationEncodingAesKey": "客户关系加密密钥"
      },
      updateType: null,
      updateCfgForm: {
        id: null,
        editObj: {}
      },
      ssoCfg: null,
      ssoCfgName: null,
      rules: {
        originChannel: [{
          required: true,
          message: '请选择来源渠道',
          trigger: 'blur'
        }],
        corpId: [{
          required: true,
          message: '请输入企业ID',
          trigger: 'blur'
        }],
        corpName: [{
          required: true,
          message: '请输入企业名称',
          trigger: 'blur'
        }],
        agentId: [{
          required: true,
          message: '请输入应用ID',
          trigger: 'blur'
        }],
        agentName: [{
          required: true,
          message: '请输入应用名称',
          trigger: 'blur'
        }],
        agentSecret: [{
          required: true,
          message: '请输入应用密钥',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getConfigCombobox();
    this.getPage();
  },
  methods: {
    getConfigCombobox: function getConfigCombobox() {
      var _this = this;
      (0, _wx_work_config.wxWorkCfgCombobox)().then(function (res) {
        var data = res.data;
        if (data) {
          _this.comboboxList = data.records;
        }
      });
    },
    getPage: function getPage() {
      var _this2 = this;
      (0, _wx_work_config.queryWxWorkCfgPage)(this.listQuery).then(function (res) {
        _this2.records = res.records;
      });
    },
    handleCreateCfg: function handleCreateCfg() {
      this.dialogVisible = true;
      this.initFormData();
    },
    initFormData: function initFormData() {
      this.cfgForm = {
        id: null,
        originChannel: "wx_work",
        //来源渠道
        corpId: null,
        //企业ID
        corpName: null,
        //企业名称
        agentId: null,
        //应用ID
        agentName: null,
        //应用名称
        agentSecret: null,
        //应用密钥
        cropAddrBookSecret: null,
        //企业通讯录密钥
        cropAddrBookToken: null,
        //企业通讯录token
        cropAddrBookEncodingAesKey: null,
        //企业通讯录加密密钥
        customerRelationSecret: null,
        //客户关系密钥
        customerRelationToken: null,
        //客户关系token
        customerRelationEncodingAesKey: null //客户关系加密密钥
      };
    },
    handleEditCfg: function handleEditCfg(cfg, type) {
      this.updateType = type;
      this.updateCfgForm = {
        id: cfg.id
      };
      if ('desc_info' === type) {
        this.$set(this.updateCfgForm, 'corpId', cfg.corpId);
        this.$set(this.updateCfgForm, 'corpName', cfg.corpName);
        this.$set(this.updateCfgForm, 'agentId', cfg.agentId);
        this.$set(this.updateCfgForm, 'agentName', cfg.agentName);
      } else {
        this.$set(this.updateCfgForm, type, null);
      }
      this.updateDialogVisible = true;
    },
    createCfg: function createCfg() {
      var _this3 = this;
      this.$refs['cfgForm'].validate(function (valid) {
        if (valid) {
          _this3.save();
        }
      });
    },
    save: function save() {
      var _this4 = this;
      (0, _wx_work_config.saveCfg)(this.cfgForm).then(function () {
        _this4.dialogVisible = false;
        _this4.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 3000
        });
        //重新加载
        _this4.getPage();
      });
    },
    update: function update() {
      var _this5 = this;
      (0, _wx_work_config.updateCfg)(this.updateCfgForm).then(function () {
        _this5.updateDialogVisible = false;
        _this5.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 3000
        });
        //重新加载
        _this5.getPage();
      });
    }
  }
};